<template lang="pug">
.book-now(:class="booking ? 'open' : 'close'")
  .content-container
    .close-button(@click.prevent="bookingModal(closeBooking)")
    .calendar-container
      .calendar-content
        .calendar
          v-date-picker(
            :formats="formats"
            mode="range"
            v-model="selectedDate"
            is-inline=true
            :min-date='new Date()'
            @input="inputUpdate"
          )
      .table
        .input-container
          label Checking In
          input(
            ref="checkIn"
            type="text"
            placeholder="MM/DD/YYYY"
            v-mask="'##/##/####'"
            v-model="startInput"
            @keyup.enter="$refs.checkOut.focus()"
          )
          p.error(v-if="startDateError") Please enter a valid date
        .input-container
          label Checking Out
          input(
            ref="checkOut"
            type="text"
            placeholder="MM/DD/YYYY"
            v-mask="'##/##/####'"
            v-model="endInput"
          )
          p.error(v-if="endDateError") Please enter a valid date
        Dropdown(
          :options="['No Preference', 'Shared', 'Private']"
          :title="'Room Type'"
          ref="room"
        )
        .input-container
          label Promo Code
          input(placeholder="Apply Code" v-model="code" ref="code")
    .booking-content
      .info
        p Planning ahead over a year?
        p Booking for a group larger then 8 guests?
        router-link(class="link cream" to="/booking?form=group" @click.native="bookingModal(closeBooking)") Contact Us
      button.find-room(@click.prevent="getData") Find My Room
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import VCalendar from 'v-calendar-ie11'

import { mask } from 'vue-the-mask'
import moment from 'moment'

import Dropdown from '@/components/Dropdown'

Vue.use(VCalendar)

export default {
  name: 'bookNow',
  props: {
  },
  data () {
    return {
      formats: {
        weekdays: 'WWW',
      },
      selectedDate: {
        start: new Date(),
        end: new Date(),
      },
      closeBooking: true,
      code: '',
      dropdownValue: '',
      month: '',
      day: '',
      year: '',
      startInput: '',
      endInput: '',
      startDateError: false,
      endDateError: false,
      currentYear: new Date().getFullYear(),
      validDate: null,
      room: '',
    }
  },
  mounted () {
    window.addEventListener('resize', document.getElementsByClassName('book-now')[0].classList.remove('close'))
    document.getElementsByClassName('book-now')[0].classList.remove('close')
    this.startInput = ''
    this.end = ''
    this.selectedDate.start = ''
    this.selectedDate.end = ''
  },
  watch: {
    booking () {
      this.checkPageScroll(this.booking)
      return this.booking
    },
    startInput () {
      if (this.startInput.length === 10) {
        this.convertToDate(this.startInput, 'start')
        this.validateDate()
        if (!this.validDate) {
          this.startDateError = true
          this.startInput = ''
          return
        } else {
          this.startDateError = false
          this.startDate(this.month, this.day, this.year)
          this.$refs.checkOut.focus()
          return this.startInput
        }
      }
      if (this.startInput.length > 0 || this.startInput.length < 10) {
        this.endInput = ''
      }
    },
    endInput () {
      if (this.endInput.length === 10) {
        this.convertToDate(this.endInput, 'end')
        this.validateDate()
        if (!this.validDate) {
          this.endDateError = true
          this.endInput = ''
          return false
        } else {
          this.endDateError = false
          this.endDate(this.month, this.day, this.year)
          return this.endInput
        }
      }
    },
  },
  computed: {
    ...mapState('menu', ['booking']),
  },
  methods: {
    ...mapActions('menu', ['bookingToggle']),
    bookingModal (open) {
      this.bookingToggle(!open)
      this.$emit('closeMenu', true)
      if (open) {
        this.startInput = ''
        this.endInput = ''
        this.selectedDate.start = ''
        this.selectedDate.end = ''
        this.$refs.checkIn.innerText = 'Select Date'
        this.$refs.checkOut.innerText = 'Select Date'
        this.code = ''
      }
    },
    inputUpdate () {
      var options = { month: '2-digit', day: '2-digit', year: 'numeric' }
      if (this.selectedDate.start !== this.selectedDate.end) {
        this.startInput = this.selectedDate.start.toLocaleDateString('en-US', options)
        this.endInput = this.selectedDate.end.toLocaleDateString('en-US', options)
      }
    },
    convertToDate (input, type) {
      let month = parseInt(input.slice(0, 1) === '0' ? input.slice(1, 2) - 1 : input.slice(0, 2) - 1)
      let day = parseInt(input.slice(3, 4) === '0' ? input.slice(4, 5) : input.slice(3, 5))
      let year = parseInt(input.slice(6, 10))

      this.month = month
      this.day = day
      this.year = year
    },
    startDate (month, day, year) {
      this.selectedDate.start = new Date(year, month, day)
      this.selectedDate.end = null
    },
    endDate (month, day, year) {
      this.selectedDate.end = new Date(year, month, day)
    },
    validateDate () {
      let dateToValidate = new Date(this.year, this.month, this.day).setHours(1, 0, 0)
      let today = new Date().setHours(0, 0, 0)
      let monthCheck = this.month >= 0 && this.month <= 11
      let dayCheck = this.day >= 1 && this.day <= 32
      let yearCheck = this.year >= this.currentYear && this.year <= this.currentYear + 100
      if (monthCheck && dayCheck && yearCheck && (dateToValidate >= today)) {
        this.validDate = true
      } else {
        this.validDate = false
      }
    },
    getData () {
      const mewsStart = moment(this.selectedDate.start).format('YYYY-MM-DD')
      const mewsEnd = moment(this.selectedDate.end).format('YYYY-MM-DD')

      // // Set error if date isn't filled out
      if (mewsStart === 'Invalid date') {
        this.startDateError = true
        return
      }
      if (mewsEnd === 'Invalid date') {
        this.endDateError = true
        return
      }

      // Set room code
      const noPreference = '02945ba6-727d-403b-8e7a-aacb009d7df6'
      const privateRoom = 'bcbf601a-169b-43ba-9d70-aada015e30db'
      const shared = 'c773b79a-b278-4cb7-a763-aada01619a2b'
      let room = ''

      switch (this.$refs.room.optionValue) {
        case 'Shared':
          room = shared
          break
        case 'Private':
          room = privateRoom
          break
        default:
          room = noPreference
      }

      let mewsLink = `https://www.mews.li/distributor/${room}?mewsStart=${mewsStart}&mewsEnd=${mewsEnd}&mewsRoute=rooms&mewsVoucherCode=${this.$refs.code.value}`

      window.open(
        mewsLink,
        '_blank'
      )
    },
    // Toggle the ability for body to scroll
    checkPageScroll (open) {
      if (open) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
  },
  components: {
    Dropdown,
  },
  directives: {
    mask,
  },
}
</script>

<style scoped lang="scss">
@import '@/styles/_calendar.scss';

button {
  width: 70px;
  height: 70px;
  padding: 0 20px;
}

.book-now {
  transition: opacity 0.3s linear 0.8s;
  position: fixed;
  width: 100vw;
  height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  background: $violent-sunset;

  @media (max-width: 1150px) {
    flex-direction: column;
  }

  &.close {
    height: 0;
    z-index: -1000;
    opacity: 0;
  }

  &.open {
    height: 100vh;
    z-index: 1000;
    opacity: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    visibility: visible;

    @media #{$mobile} {
      // height: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
}

.close-button {
  position: absolute;
  top: 31px;
  right: 45px;
  height: 50px;
  width: 50px;
  z-index: 1000;

  @media (max-width: 1150px) {
    position: relative;
    // background: rebeccapurple;
    width: 100%;
    height: 25px;
    right: 0;
    top: 0;
  }

  &:hover {
    cursor: pointer;
  }

  &:before, &:after {
    content: '';
    display: block;
    height: 5px;
    width: 40px;
    background: $cream;
    position: absolute;
    top: 50%;

    @media (max-width: 1150px) {
      height: 4px;
      width: 26px;
      right: 20px;
    }
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
}

.content-container {
  width: 100%;
  height: 100%;

  @media #{$mobile} {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 20px 0 110px;
  }
}

.calendar-container {
  display: block;
  width: 100%;
  height: 700px;

  @media #{$mobile} {
    height: auto;
  }
}

.calendar-content {
  position: absolute;
  width: 50%;
  left: 5%;
  top: 50px;

  @media (max-width: 1350px) {
    // width: 95%;
    padding-right: 0;
  }

  @media #{$mobile} {
    position: unset;
    // top: 40px;
    height: auto;
    display: block;
    margin: 0 auto;
    // margin-top: 150px;
    width: 90%;
    padding: 0;
    flex-direction: column;
  }
}

.calendar {
  width: 100%;
}

.table {
  position: absolute;
  right: 5%;
  width: 35%;
  top: 135px;

  @media #{$mobile} {
    position: unset;
    margin: 0 auto;
    width: 100%;
    padding: 0 6%;
  }

  .input-container {
    margin-bottom: 42px;
  }

  input {
    width: 100%;
    background: transparent;
    border: none;
    font-size: $book-now-font-size;
    line-height: 1;
    font-family: 'Martha Regular';
    text-transform: uppercase;
    text-align: right;
    color: $cream;
    z-index: 1;
    @media (max-width: 1150px) {
      font-size: 1.125rem;
    }

    &::placeholder {
      font-size: $book-now-font-size;
      line-height: 1;
      font-family: 'Martha Regular';
      text-transform: uppercase;
      text-align: right;
      color: $cream;
      @media (max-width: 1150px) {
        font-size: 1.125rem;
      }
    }

    &:focus {
      outline: none;
    }
  }

  p {
    font-size: 1.8375rem;
    line-height: 1;
    text-transform: uppercase;
    @media (max-width: 1150px) {
      font-size: 1.125rem;
    }

    &.error {
      position: absolute;
      right: 0;
      font-size: 18px;
      bottom: -24px;
      color: $black;
      text-transform: none;
    }
  }

  label {
    font-size: 1.75rem;
    position: absolute;
    width: 100%;
    bottom: -7px;

    @media (max-width: 1150px) {
      line-height: 1;
      font-size: 1.5rem;
      bottom: -3px;
    }
  }
}

.booking-content {
  position: relative;
  width: 100%;
  bottom: 130px;
  left: 5.5%;

  @media #{$mobile} {
    left: 0;
    bottom: 0;
    padding: 0 6%;
  }

  .info {
    margin-top: 20px;

    @media #{$mobile} {
      margin-top: 0;
    }

    @media #{$mobile} {
      display: block;
    }
    p, a {
      color: $cream;
    }

    p {
      line-height: 1.2;
      font-size: .83125rem;
      @media #{$mobile} {
        width: 60%;
        font-size: 0.8em;
        margin-bottom: 10px;

        &:last-of-type {
          margin: 0;
        }
      }
    }

    a {
      font-size: .9625rem;;
      margin-top: 20px;
      display: inline-block;

      &:hover {
        border-color: $cream;
      }
    }
  }
}
.find-room {
  color: $black;
  background: $cream;
  margin-top: -110px;
  display: block;
  right: 9%;
  bottom: 10%;
  border-radius: 50%;
  width: 112px;
  height: 112px;
  font-size: .9625rem;
  padding: 0 30px;
  text-align: center;
  text-transform: uppercase;
  font-family: 'Martha Black';
  border: none;
  transition: all 0.4s ease;
  position: absolute;
  bottom: 80%;

  @media #{$mobile} {
    width: 100px;
    height: 100px;
    font-size: 1rem;
    padding: 10px 20px;
    right: 6%;
    bottom: 0;
    position: absolute;
    margin: 0;
  }

  &:hover {
    text-decoration: none;
    background: $black;
    color: $cream;
    cursor: pointer;
  }
}

/deep/ .vc-arrows-container {
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;

  @media #{$mobile} {
    width: 80%;
  }
  .vc-flex {
    background-image: url('../assets/images/dropdown-arrow.svg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 17.5px;
    height: 1.25rem;
    transform: rotate(90deg);

    &:last-of-type {
      transform: rotate(-90deg);
    }

    &:focus {
      background-color: transparent;
      background-image: url('../assets/images/dropdown-arrow.svg');
    }

    svg {
      display: none;
    }
  }
}
</style>
